module.exports = __webpack_public_path__ + "static/media/intereses.f82c8d26.png";